!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("react"), require("nouislider")) : "function" == typeof define && define.amd ? define(["react", "nouislider"], e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).ReactNouislider = e(t.React, t.nouislider);
}(this, function (t, e) {
  "use strict";

  function n(t) {
    return t && "object" == typeof t && "default" in t ? t : {
      default: t
    };
  }

  var r = n(t),
      o = n(e);

  function i(t) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function u(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function a() {
    return (a = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  function c(t, e) {
    var n = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function f(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          r || null == a.return || a.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(t, e) || s(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function l(t) {
    return function (t) {
      if (Array.isArray(t)) return y(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || s(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function s(t, e) {
    if (t) {
      if ("string" == typeof t) return y(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(t, e) : void 0;
    }
  }

  function y(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var n = 0, r = new Array(e); n < e; n++) {
      r[n] = t[n];
    }

    return r;
  }

  var d = function d(t) {
    return Object.entries(t).sort().reduce(function (t, e) {
      var n = f(e, 2),
          r = n[0],
          o = n[1];
      return t[r] = o, t;
    }, {});
  },
      p = function p(t, e) {
    return "number" == typeof t && "number" == typeof e || "string" == typeof t && "string" == typeof e ? t === e : Array.isArray(t) && Array.isArray(e) ? JSON.stringify(t) === JSON.stringify(e) : "object" === i(t) && "object" === i(e) && JSON.stringify(d(t)) === JSON.stringify(d(e));
  },
      b = function b(t, e) {
    var n = t.start,
        r = t.step,
        o = t.disabled,
        i = t.range;
    return e.step === r && p(e.start, n) && e.disabled === o && p(e.range, i);
  },
      m = function m(e) {
    var n = f(t.useState(null), 2),
        i = n[0],
        s = n[1],
        y = r.default.createRef();
    t.useEffect(function () {
      var t = e.instanceRef,
          n = t && Object.prototype.hasOwnProperty.call(t, "current");
      return t && t instanceof Function && t(y.current), n && (t.current = y.current), function () {
        n && (t.current = null);
      };
    }, [y]);

    var d = function d(t) {
      var e = Number(t.target.getAttribute("data-value"));
      i && i.set(e);
    },
        p = function p(t) {
      var e = y.current;
      e && (t ? e.setAttribute("disabled", !0) : e.removeAttribute("disabled"));
    },
        b = e.onUpdate,
        m = e.onChange,
        v = e.onSlide,
        g = e.onStart,
        O = e.onEnd,
        h = e.onSet,
        S = function S(t) {
      g && (t.off("start"), t.on("start", g)), v && (t.off("slide"), t.on("slide", v)), b && (t.off("update"), t.on("update", b)), m && (t.off("change"), t.on("change", m)), h && (t.off("set"), t.on("set", h)), O && (t.off("end"), t.on("end", O));
    },
        j = function j() {
      e.clickablePips && l(y.current.querySelectorAll(".noUi-value")).forEach(function (t) {
        t.style.cursor = "pointer", t.addEventListener("click", d);
      });
    },
        A = function A() {
      var t = o.default.create(y.current, function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(n), !0).forEach(function (e) {
            u(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }

        return t;
      }({}, e));
      S(t), s(t);
    };

    t.useEffect(function () {
      var t = e.disabled,
          n = y.current;
      return n && (p(t), A()), function () {
        i && i.destroy(), n && l(n.querySelectorAll(".noUi-value")).forEach(function (t) {
          t.removeEventListener("click", d);
        });
      };
    }, []), t.useEffect(function () {
      i && j();
    }, [i]);
    var E = e.start,
        w = e.disabled,
        P = e.range,
        N = e.step;
    t.useEffect(function () {
      i && (!function (t) {
        y.current.noUiSlider.updateOptions(t);
      }({
        range: P,
        step: N
      }), i.set(E), j()), p(w);
    }, [E, w, P, N]), t.useEffect(function () {
      i && S(i);
    }, [b, m, v, g, O, h]);
    var k = e.id,
        U = e.className,
        I = e.style,
        R = {};
    return k && (R.id = k), U && (R.className = U), r.default.createElement("div", a({}, R, {
      ref: y,
      style: I
    }));
  };

  return m.defaultProps = {
    animate: !0,
    behaviour: "tap",
    className: null,
    clickablePips: !1,
    connect: !1,
    direction: "ltr",
    disabled: !1,
    format: null,
    margin: null,
    limit: null,
    keyboardSupport: !0,
    id: null,
    instanceRef: null,
    padding: 0,
    pips: null,
    snap: !1,
    step: null,
    style: null,
    orientation: "horizontal",
    tooltips: !1,
    onChange: function onChange() {},
    onEnd: function onEnd() {},
    onSet: function onSet() {},
    onSlide: function onSlide() {},
    onStart: function onStart() {},
    onUpdate: function onUpdate() {}
  }, r.default.memo(m, b);
});